import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { BaselineEngine, COMPUTE_MODE, FIELD_KIND, FeiKeyDef, KeyPair, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';
import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_ESCAPE, WizDateUtils, WizStringUtils } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizAgGrid,
  WizBasePopUp,
  WizCheckbox,
  WizDatasource,
  WizDateField,
  WizDropdown,
  WizHgroup,
  WizNumericInput,
  WizTextInput,
  WizEventManager, WizEvent,
  WizPopUp
} from '@wizeoo/akm-component-lib';
import { ColDef } from 'ag-grid-community';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';

import { IWidget, IWidgetFilter, IWidgetFilterItem } from '../../../../../manager/widgets/i-widget';
import { WIDGET_GLOBAL_KIND, WIDGET_KIND } from '../../../../../model/enums';
import { ViewData } from '../../../../../model/view.data';
import { ComparatorVO } from '../../../../../vo/common/tool/comparator.vo';
import { ChronocodeVO } from '../../../../../vo/core/chronocode.vo';
import { FreeDataVO } from '../../../../../vo/core/freedata.vo';
import { FreedataArgsVO } from  '../../../../../vo/core/freedataargs.vo';
import { FreedataValueVO } from  '../../../../../vo/core/freedatavalue.vo';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { FakeVO } from '../../../../../vo/common/tool/fake.vo';
import { WizColDef } from '../../../../../manager/workingdata/fei.engine';
import { Model } from '../../../../../model/model';

/** contrat d'interface pour les données manipulée dans cette PopUp */
export interface filterPopData {
  popReference: WizPopUp; // cette popUp, pour redimensionnement
  filter: IWidgetFilter;
  callback: Function;
}



@Component({
  // filtre de Grid
  selector: 'pivot-filter-extended-pop',
  templateUrl: './pivot-filter-extended.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotFilterExtendedPop extends WizBasePopUp {
  @ViewChild('agGrid') agGrid: WizAgGrid<IWidgetFilterItem>;
  @ViewChild('popFilter', { read: FilterComponent, static: false }) popFilter: FilterComponent; // zone du filtre... du filtre
  @ViewChild('gpOperator') gpOperator: WizHgroup; // zone de comparateur pour champs numériques

  @ViewChild('ddlComparator') ddlComparator: WizDropdown; // drop de choix du comparateur
  
  @ViewChild('ti') ti: WizTextInput; // zone de saisie du texte de comparaison
  @ViewChild('ni', { read: WizNumericInput, static: false }) ni: WizNumericInput;
  @ViewChild('da', { read: WizDateField, static: false }) da: WizDateField;
  @ViewChild('cb', { read: WizCheckbox, static: false }) cb: WizCheckbox;

  @ViewChild('ni2', { read: WizNumericInput, static: false }) ni2: WizNumericInput;
  @ViewChild('da2', { read: WizDateField, static: false }) da2: WizDateField;

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      this.doCancel();
    }
  }

  // dimensions demandées
  public static get width(): string {
    return this.baseWidth.toString() + 'px';
  } 
  public static get height(): string {
    return this.baseHeight.toString() + 'px';
  } 
  public static baseHeight: number = 450; // hauteur avec tout, statique pour prise externe sur ouverture
  public static smallHeight: number = 200; // mode remote, petite taille
  public static baseWidth: number = 350; // largeur, statique pour prise externe sur ouverture
  
  public realHeight: number = 0; // hauteur réelle, on va soustraire ce qui est masqué


  public filter: IWidgetFilter; // la data manipulée
  public widget: IWidget; // le widget source
  private fei: FeiVO; // le fei source
  protected wcio: WidgetConfigurationItemObj; // le contexte pour ce filtre
  protected fkd: FeiKeyDef; // la pkd liée
  protected datakind: string = null;
  protected existOnly: boolean = false; // utiliser uniquement les valeurs existantes dans le pool
  

  public doSaveFlag: boolean = true;
  public hasChange: boolean = false; // une modif sur la collection

  
  public currentComparator: string = null; // comparateur actif pour la regex
  public currentPartOne: any = null; // première valeur de la regex
  public currentPartTwo: any = null; // seconde valeur de la regex

  /** widget en mode remote, pas de liste de valeurs pour les mesures */
  public get remoteMode():boolean {
    let result: boolean = false;
    if(!!this.widget && !!this.fkd) {
      let isMeasure: boolean = this.fkd.isMeasure;
      let isRemote: boolean = this.widget.model.widgetEngine.widgetIsCompute(this.widget);
      result = isMeasure && isRemote;
      // console.log('remote', isMeasure, isRemote);
    }
    return result;
  }

  /** définition de la bonne taille */
  protected getMyRealSize(): void {
    if (this.realHeight !== PivotFilterExtendedPop.baseHeight) {
      // console.log("delta size", this.realHeight);
      this.datas.popReference.dialogRef.updateSize(PivotFilterExtendedPop.baseWidth + 'px', this.realHeight + 'px');
    }
  }

   /* ##############################################################################
          gestion des FD
    ############################################################################### */ 

    private freedata: FreeDataVO = null;
    private freedataValueMap: Map<string, FreedataValueVO> = null;
    private argMap: Map<string, FreedataArgsVO> = null;
    private realField: string = null;
    private otherField: FreedataArgsVO = null; // on utilise un autre champ que label, c'est qui ?
    private useNonUniqueField: boolean = false; // le champ demandé n'est pas unique (code)
    private useSubFreedata: boolean = false; // le champ demandé pour le rendu est un lien vers un autre FD
    private subFreedataValueMap: Map<string, FreedataValueVO> = null; // Map des sous-FDV en cas de rendu objet
      











  columns: ColDef[]; // Colonnes du grid
  /** la DS du grid */
  public lineDS: WizDatasource<IWidgetFilterItem> = new WizDatasource<IWidgetFilterItem>([])
    .setSelectionMode('multiple')
    .build();

  /** liste des comparateurs pour les champs numériques */
  public comparatorDS: WizDatasource<ComparatorVO> = new WizDatasource<ComparatorVO>([]) // fake des comparateurs
  .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
  .setSelectionMode('single')
  .build();

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }


  /** flag d'affichage de la zone de comparateur */
  public showComparator: boolean = true;

  /** flag d'affichage de l'icone de suppression de l'expression */
  public hasExp(): boolean {
    if (this.comparatorDS?.selectedItem) {
      return true;
    }
    return false;
  }

  /** flag pour afficher la zone de choix d'éléments
   * valable pour tout le monde SAUF les mesures en mode globalFilter
   */
  public get gridDisplayMode(): string {
    return 'inline'; // this.globalMeasureFilter ? 'none' : 'inline';
  }

  /** 
   * je suis une mesure en filtre global
   */
  public isGlobalFilter(): boolean {
    if(this.widget?.widgetKind === WIDGET_KIND.GLOBAL_FILTER) {
      return true;
    }
    return false;
  }


  /** 
   * je suis une mesure en filtre global
   */
  public get globalMeasureFilter(): boolean {
    if(this.widget?.widgetKind === WIDGET_KIND.GLOBAL_FILTER && this.fkd?.isMeasure) {
      return true;
    }
    return false;
  }


  show(): void {
    super.show();
    let popDatas: filterPopData = this.datas;
    this.filter = popDatas.filter;
    this.callback = popDatas.callback;
    this.wcio = this.filter.wcio;
    this.widget = this.filter.widget;
    this.fei = this.widget.fei as FeiVO;
    this.fkd = this.filter.fkd;
    this.datakind = this.fkd.datakind;
    this.existOnly = this.wcio.filtOnEx;

    // gestion de la taille en mode remote
    if(!this.remoteMode) {
      this.realHeight = PivotFilterExtendedPop.baseHeight;
    } else {
      this.realHeight = PivotFilterExtendedPop.smallHeight;
    }
    
    this.feedDatasources(); // alimentation des données
    this.buildRegex(); // construction de la zone regex
    
    this.addListeners(); // pose des écouteurs
    
    this.getMyRealSize();
  }


  /** retourne le nombre de décimales selon le format du champ filtré */
  private getDecimal(fkd: FeiKeyDef): number {
    let result: number = 3;
    if(fkd.isMeasure) {
      result = fkd.measure.nbDecimal;
    }
    return result;
  }

  /** construction initiale de la regex */
  public buildRegex(): void {
    if (!!this.filter.regex) { // construction des éléments de regex;   
      const part: string[] = this.filter.regex.split(ViewData.KEY_SEPARATOR);
      this.currentComparator = part[0];
      if (part.length > 1) {
        this.currentPartOne = part[1];
      }
      if (part.length === 3) {
        this.currentPartTwo = part[2];
      }
    }

    // alimentation de la DS des comparateurs
    let toUseKind: string = this.datakind;
    if(this.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA && this.useSubFreedata) {
      toUseKind = FIELD_KIND.STRING;
    }
    this.comparatorDS.setSource(ViewData.getInstance().getExtComparatorSet(toUseKind));

    if (!!this.currentComparator) {
      // console.log('filter pop filtEx', this.pfo.wcio.filtExp);
      const part: string[] = this.filter.regex.split(ViewData.KEY_SEPARATOR);
      const comp: ComparatorVO = this.comparatorDS.getItemByKey(this.currentComparator);
      this.comparatorDS.select([comp]);
    } else {
      this.clearExp();
    }

    this.manageRegex(); 
  }

  /** gestion des champs visibles pour l'expression */
  public manageRegex(): void {
    this.hideExpComponent();
    if (this.datakind && this.comparatorDS?.selectedItem) {    
      const nbParams: number = this.comparatorDS.selectedItem.nbParams;   
      if( nbParams > 0) { // vide ou nonvide
        switch(this.datakind) {
          case FIELD_KIND.NUMBER:
            this.ni.visible = true;
            this.ni.nbDecimal = this.getDecimal(this.fkd);
            this.ni.wizNumber = Number(this.currentPartOne);
            if (nbParams === 2) {
              this.ni2.visible = true;
              this.ni2.nbDecimal = this.getDecimal(this.fkd);
              this.ni2.wizNumber = Number(this.currentPartTwo);
            }
            break;
            case FIELD_KIND.INT:
              this.ni.visible = true;
              this.ni.nbDecimal = 0;
              this.ni.wizNumber = Number(this.currentPartOne);
              if (nbParams === 2) {
                this.ni2.visible = true;
                this.ni2.nbDecimal = 0;
                this.ni2.wizNumber = Number(this.currentPartTwo);
              }
              break;
          case FIELD_KIND.DATE:
            this.da.visible = true;
            this.da.wizValue = WizDateUtils.stringToDate(this.currentPartOne);
            if (nbParams === 2) {
              this.da2.visible = true;
              this.da2.wizValue = WizDateUtils.stringToDate(this.currentPartTwo);
            }
            break;
          case FIELD_KIND.STRING:
          case FIELD_KIND.TRS_LABEL:
          case FIELD_KIND.OBJECT:
          case FIELD_KIND.LIST:
            this.ti.visible = true;
            this.ti.wizValue = this.currentPartOne;
            break;
          case FIELD_KIND.BOOLEAN:
            this.cb.visible = true;
            this.cb.wizChecked = !!this.currentPartOne;
            break;         
        }
      }
    }
  }

  /** masquer tous les champs d'expression */
  private hideExpComponent(): void {
    this.ti.visible = false;
    this.ni.visible = false;
    this.da.visible = false;
    this.cb.visible = false;
    this.ni2.visible = false;
    this.da2.visible = false;
  }

  /**
   * suppression de l'expression
   */
  public clearExp(): void {
    this.comparatorDS.clearSelection();
    this.hideExpComponent();
  }


  /**
   * Synchronisation du selected
   * @param pEvent wizEvent contenant l'item sélectionné
   */
  private innerSelectionChange(pEvent: WizEvent): void {
    this.hasChange = true;
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    
    let fkd: FeiKeyDef = this.filter.fkd;
    if(fkd?.isMeasure) {
      this.feedFromMeasure();
      return;
    }

    // A partir d'ici, on est soit un Freedata, soit un chronocode

    let moreFields: string[] = []; // champs complémentaire pour le rendu de la pop en cas de FD

    this.columns = this.widget.model.widgetEngine.buildFilterColumns(this.filter, moreFields); // générer les colonnes depuis le contexte
    // console.log('columns', this.columns, moreFields);
    this.popFilter.configure(moreFields, null, null); // prise en compte comme filtre

    this.lineDS.setFilter(this.valFilterFunc.bind(this));

    // alimentation de la DS, on va construire les pivotFilterEntry
    // on prend soit tout les FDV, soit uniquement les valeurs par défaut
    // en cas de valeurs existantes uniquement, on prend TOUT si la DS est vide (sinon on peut pas alimenter les filtres à vide)
    let protods: IWidgetFilterItem[];
    let ds: IWidgetFilterItem[];

    // les différentes valeurs à alimenter
    let filterEntryMap: Map<string, IWidgetFilterItem> = new Map();
    // les valeurs sélectionnées
    let filterSelectMap: Map<string, IWidgetFilterItem> = new Map();


    // aucun intérêt pour les FDs
    // let lineMap: Map<number, Map<string, Map<string, WidgetLine>>> = this.widget.model.dataEngine.getAllLines(2, "MAIN");
    

    // // prise du FEI 
    // let level: number = this.wcio.step || this.widget.fei.visionStepLevel; // step du widget par défaut ou injection
    // let fei: FeiVO = this.widget.model.dataEngine.getFei(COMPUTE_MODE.LOCAL, level, WizConstants.BASE_SCENARIO) as FeiVO;
    // this.fei = fei; // surcharge possible, si step défini dans la conf du filtre
    let lines: WidgetLine[] = this.widget.mainDS.getWorkedSource();
    // let lines: WidgetLine[] = this.fei?.getAllLines() || null; 

    if(this.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE && lines.length === 0) { // rien dans la DS, on fait rien
      this.existOnly = false;
    }

    // TODO TODO gérer existOnly sur les FDV
    if(this.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA) { 
      this.existOnly = false;
    }

    let entry: IWidgetFilterItem; // l'item à créer
    let rawVal: string; // la valeur brute sur la Widgetline, qui sert de clé
    let sortKey: any;
    let label: string;
    let moreArgs: { [key: string]: string } = null; // les champs complémentaires à injecter en cas de moreFields

    // en fonction du type d'élément manipulé
    if(this.fkd.isChrono) {    
      // prise du niveau
      let level = Number(this.fkd.fullCode.split(WizConstants.CONTEXT_SEPARATOR)[1]);
      // collecte du chronocode maître
      let mainChrono: ChronocodeVO = this.widget.model.chronocodeEngine.getChronocode(this.widget.model.currentVision.chronoCode);
      // collecte des valeurs pour le niveau
      let chronovals: ChronocodeVO[] = this.widget.model.chronocodeEngine.getChildrenByLevel(mainChrono, level);

      if(this.existOnly) { // seulement ce qui existe    
        lines.forEach((line: WidgetLine) => {
          if(line.ch?.size > 0) {
            [...line.ch.values()].forEach((sub: WidgetLine) => {
              this.feedChronFromLine(sub, this.fkd.fullCode, filterEntryMap, filterSelectMap);
            });
          } else {
            this.feedChronFromLine(line, this.fkd.fullCode, filterEntryMap, filterSelectMap);
          } 
        });  
      } else { // tout le chrono
        chronovals.forEach((cron: ChronocodeVO) => {
          rawVal = cron.code;
          entry = {rawVal, sortKey: cron.startDate, label: cron.trsLabel};
          filterEntryMap.set(rawVal, entry);
          if(this.filter.values?.has(rawVal)) {
            filterSelectMap.set(rawVal, entry);
          }
        });
      }
      // on trie
      ds = [...filterEntryMap.values()].sort((a, b) => a.sortKey - b.sortKey);

      // LMA prise du bon dataKind en cas d'utilisation d'autre champs
      // contrôle du champ de rendu sur les FDVs. Si c'est "OBJECT", c'est un sous-FD...
      if(!!this.wcio.fdvf) { 
        let field: FakeVO = this.widget.model.chronocodeEngine.getChronoFieldByCode(this.wcio.fdvf);
        if(field) {
          this.datakind = field.datakind;
        }
      }
    } 
    else if(this.fkd.isFreedata) {    
      // on prend le code du FD
      this.freedata = this.widget.model.freedataEngine.getFreeData(this.wcio.cod.split(ViewData.CONTEXT_SEPARATOR)[0]);
      this.freedataValueMap = new Map(this.widget.model.freedataEngine.getFreedataValuesByLevel(this.wcio.cod).map(item => [item.code, item]));
      this.argMap = new Map(this.freedata.allFieldsAsArgs.map(item => [item.code, item]));
      

      // contrôle du champ de rendu sur les FDVs. Si c'est "OBJECT", c'est un sous-FD...
      if(!!this.wcio.fdvf) { 
        this.realField = this.widget.model.widgetEngine.fdvfSplitter(this.wcio.fdvf)[0]; 
        this.otherField = this.argMap?.get(this.realField); // on regarde quel est le champ
        if(!!this.otherField) {
          this.datakind = this.otherField.dataType;
          let uniqueFields: string[] = [WizConstants.FIELD_CODE, WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL];
          if(uniqueFields.indexOf(this.wcio.fdvf) === -1) {
            this.useNonUniqueField = true;
          }
          if (this.otherField.dataType === FIELD_KIND.OBJECT) { // c'est un subFD, on écrase le dataKind, et on alimente la map subFDV
            this.useSubFreedata = true;
            if(this.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE) {
              this.showComparator = false;
            }
            
            this.subFreedataValueMap = new Map(this.widget.model.freedataEngine.getFreedataValuesByLevel(this.otherField.datas).map(item => [item.code, item]));
          }
        }
      }

      // collecte des FDV à utiliser
      let realSet: Set<string> = new Set(); // les clés du vrai FD  (les CODES)
      if(this.existOnly) { // seulement ce qui existe 
        lines.forEach((line: WidgetLine) => {      
          // Si la valeur est null, c'est chaine vide ('') qu'on va rechercher
          realSet.add(BaselineEngine.getRawKeyOrValue(this.fei, line, this.fkd.fullCode)??'');
        });
      } else { // tous les freedataValues (ou filtre global)

        //filtre la liste des FREEDATAs en cas de filtre User
        let filteredMap: Map<string, FreedataValueVO> = this.widget.model.widgetEngine.restrictFreedataMapFromUser(this.freedataValueMap);
        realSet = new Set(filteredMap.keys());


        // filtre sur les filtres précédents
        let filters: Map<string, IWidgetFilter> = this.widget.filters; // tous les filtres
        let meKey: string = [this.wcio.cod, this.wcio.fdvf].join('');
        [...filters.keys()].forEach(k => {
          
          if(realSet.size <=0) { // j'suis déjà vide
            return;
          }

          let survivorSet: Set<string> = new Set(); // ceux qui vont survivre
          let manageByArg: boolean = false; // filtre précédent dont je possède un arg
          let myArgFromBrother: FreedataArgsVO = null; // mon arq qui correspond au filtre
           


          if(k.replace('null', '') !== meKey && (filters.get(k).active || filters.get(k).mandatory)) { // pas moi & actif ou mandatory
            // filtre sur l'un de mes args
            let brotherFilter: IWidgetFilter = filters.get(k);
            let brotherPool: Set<string> = brotherFilter.realValues || brotherFilter.values;
            let brotherFDCode: string = null;
            if(brotherFilter.fkd?.isFreedata) {
              brotherFDCode = brotherFilter.fkd.fullCode;
            }
            // on balaie la map des args pour chercher une correspondance de datas (source)    
            [...this.argMap.values()].forEach(fda => {
              if(fda.datas === brotherFDCode) {
                manageByArg = true;
                myArgFromBrother = fda;
                // console.log('myArg Value', brotherFilter, fda);
                return;
              }
            });

            if(manageByArg) { // dans ce cas, filtrer pour mon arg contient ....
              
              let baseFDV: FreedataValueVO;
              if(brotherFilter.mandatory && brotherPool?.size <= 0) { // mandatory sans valeur
                realSet = new Set(); // on rince tout
              } else if(brotherPool?.size > 0) { // un filtre est en place
                [...realSet.keys()].forEach( s => {
                  baseFDV = this.widget.model.freedataEngine.getFreedataValue(this.freedata.code, s);
                  if(baseFDV) {
                    let realS: string = this.widget.model.freedataEngine.getFDValue(baseFDV, myArgFromBrother.code);
                    if(realS) {
                      realS = realS.split(WizConstants.CONTEXT_SEPARATOR).pop();
                    }
                    // console.log('realS', realS, brotherPool);
                    if(brotherPool.has(realS)) {
                      survivorSet.add(s);
                    }
                  }
                  
                });
                realSet = survivorSet;
              }


            } else if(k.startsWith(this.wcio.cod)) { // même FD#level
                // console.log('k', k, filters.get(k));
                // dans ce cas, limiter à cette liste
                if(brotherPool?.size > 0) { // un filtre est en place
                  
                  [...realSet.keys()].forEach( s => {
                    if(brotherPool.has(s)) {
                      survivorSet.add(s);
                    }
                  });
                  realSet = survivorSet;
                }

            }
          }
          
        });

      }


      let isNumeric: boolean = this.widget.model.dataEngine.datakindIsNumeric(this.datakind);

      let fdv: FreedataValueVO; // le FDV porteur des infos
      let subFdv: FreedataValueVO; // le sous-FDV en cas de champ Objet
      [...realSet.values()].forEach((sourceRaw: string) => { // on balaie les clés utiles
        fdv = this.freedataValueMap.get(sourceRaw);
        rawVal = null;
        sortKey = null;
        if(!!fdv) {
          if(this.useSubFreedata) { // on utilise un sous-FD, il va falloir prendre sa clé à lui pour la rawVal
            let fdvValueForSub: string = fdv.argsObjVO[this.realField];
            if(fdvValueForSub) {
              let parts = fdvValueForSub.split(WizConstants.CONTEXT_SEPARATOR);
              subFdv = this.subFreedataValueMap.get(parts[1]); 
              rawVal = subFdv?.code || null; //''; // la clé, c'est simplement le code du sous-FDV
              sortKey = subFdv?.trsLabel;
              label = subFdv?.trsLabel;
              if(!!moreFields) { // champs supplémentaires requis
                moreArgs = subFdv?.argsObjVO;
              }
            } 
          } else {          
            if(this.useNonUniqueField) {
              rawVal = fdv.argsObjVO[this.realField]; // la clé, c'est la valeur pour le arg
              if(this.datakind === FIELD_KIND.DATE && rawVal) { // possible date sur 14, on veut juste les 8 premiers
                rawVal = rawVal.substring(0,8);
              }

            } else {
              rawVal = fdv.code; // la clé, c'est simplement le code du FDV
            }

            if(isNumeric) {
              sortKey = rawVal;
            } else {
              sortKey = fdv?.trsLabel;
            }
            
            label = fdv?.trsLabel;

            if(!!moreFields) { // champs supplémentaires requis
              moreArgs = fdv.argsObjVO;
            }
          }
        }

        // ajout à la map d'éléments de filtre
        if(rawVal !== null) {
          if(!filterEntryMap.has(rawVal)) { // pas encore repéré
           
            entry = {rawVal, sortKey, label,...moreArgs}; // on fusionne avec moreArgs
            filterEntryMap.set(rawVal, entry);
            let originRawVals: Set<string> = new Set(); // les codes des vrais FDV, pas le sub
            originRawVals.add(sourceRaw);
            entry.originRawVals = originRawVals;
          } else {
            // if(useSubFreedata) {
              // prendre la vraie entrée, gros naze...
              entry = filterEntryMap.get(rawVal);
              entry.originRawVals.add(sourceRaw);
            // }
          }
  
          if(this.filter.values?.has(rawVal)) { // on prend par contre l'entrée de subFDV pour mémoriser le filtre
            filterSelectMap.set(rawVal, entry);
          }
        }

      });

      // alimentation de la DS
      if(isNumeric) {
        ds = [...filterEntryMap.values()].sort((a, b) => a.sortKey - b.sortKey);
      } else {
        ds = [...filterEntryMap.values()].sort((a, b) => a.sortKey.localeCompare(b.sortKey));
      }

    } 

    this.lineDS.setSource(ds); 
    this.lineDS.select([...filterSelectMap.values()]);
  }

  /**
   * alimentation des chronos dispo en mode existOnly
   * @param wl 
   * @param fkdCode 
   * @param filterEntryMap 
   * @param filterSelectMap 
   */
  private feedChronFromLine(wl: WidgetLine, fkdCode: string, filterEntryMap: Map<string, IWidgetFilterItem>, filterSelectMap: Map<string, IWidgetFilterItem>): void {
      let rawVal = BaselineEngine.getRawKeyOrValue(this.fei, wl, fkdCode)??''; // Si la valeur est null, c'est chaine vide ('') qu'on va rechercher
      
      if(!filterEntryMap.has(rawVal)) { // pas encore ajouté       
        let myChron: ChronocodeVO;  myChron = this.widget.model.chronocodeEngine.getChronocode(rawVal);
        let label: string = myChron.trsLabel; 
        let sortKey: any = myChron.startDate;
        let entry: IWidgetFilterItem = {rawVal, sortKey, label};
        
        filterEntryMap.set(rawVal, entry);
        if(this.filter.values?.has(rawVal)) {
          filterSelectMap.set(rawVal, entry);
        }
      }
  }

  /**
   * Fonction de filtre
   * @param item Elément de la liste testé
   */
  protected valFilterFunc(item: IWidgetFilterItem): boolean {   
    let fkd: FeiKeyDef = this.filter.fkd;
    if(fkd?.isMeasure) { // contrôle plus poussé sur les mesures de type Filter
      return this.listMeasureFilter(item);
    }
    return this.popFilter.checkVisible(item);
  }

  private listMeasureFilter(item: IWidgetFilterItem): boolean { 
    let baseVal: string = this.popFilter.basicValue;
    console.log('yo', item, this.popFilter.basicValue )  
   
       
    let partResult: boolean = false;
    if (baseVal) { // test générique, l'un des fields doit contenir la valeur en UpperCase
        if(item.label) {
          if (WizStringUtils.containUpper(item.label, baseVal)) {
             partResult = true;
           }
        } else {
          item.labels?.forEach((field: string) => { // pour tous les champs cibles
            if (!!field && WizStringUtils.containUpper(field, baseVal)) {
              partResult = true;
            }
          });
        }


    } else { // pas de critère générique
        partResult = true;
    }
    if (!partResult) { // texte générique et aucun match, sortie
      return false;
    } 
    
    
    return true;
  }

  /**
   * Refresh du filtre
   * @param event : Evenement de changement dans la zone de filtre
   */
  private refreshFilter(event: WizEvent = null): void {
    this.lineDS.refresh();
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    // modification de la sélection
    WizEventManager.addListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.innerSelectionChange);
    // modification du filtre
    WizEventManager.addListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER, this.refreshFilter);
    // modification du comparateur
    WizEventManager.addListener(this, this.gpOperator, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateExp);
  }

  /** Sauvegarde */
  public save(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /**
   * modification de la regex
   * @param e 
   */
  private updateExp(e: WizEvent): void {
    this.hasChange = true;
    // console.log('updateExp', e.currentTarget);
    switch(e.component) {
      case this.ddlComparator:
        this.manageRegex();
        break;
    }
  }

  public onHide() {
    WizEventManager.removeListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED);
    WizEventManager.removeListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER);
    WizEventManager.removeListener(this, this.gpOperator, WIZ_EVENT_TYPE.MODEL_UPDATE);
    
    let newExp: string = null; // contrôle de l'expression
    // construction de la newExp
    if (this.comparatorDS.selectedItem) {
      const parts: string[] = [];
      parts.push(this.comparatorDS.selectedItem.code);
      const nbParams: number = this.comparatorDS.selectedItem.nbParams;
      if( nbParams > 0) { // vide ou nonvide
        switch(this.datakind) {
          case FIELD_KIND.NUMBER:
          case FIELD_KIND.INT:  
            parts.push(this.ni.wizNumber?.toString());
            if (nbParams === 2) {
              parts.push(this.ni2?.wizNumber?.toString());
            }
            break;
          case FIELD_KIND.DATE:
            parts.push(WizDateUtils.dateToString(this.da.wizValue));
            if (nbParams === 2) {
              parts.push(WizDateUtils.dateToString(this.da2.wizValue));
            }
            break;
          case FIELD_KIND.STRING:
          case FIELD_KIND.TRS_LABEL:
          case FIELD_KIND.OBJECT:
          case FIELD_KIND.LIST:
            parts.push(this.ti.wizValue);
            break;
          case FIELD_KIND.BOOLEAN:
            parts.push(this.cb.wizChecked ? '1': '0');
            break;         
        }
      }
      newExp = parts.join(ViewData.KEY_SEPARATOR);
    }

    if (newExp != this.filter.regex) {
      this.hasChange = true;
    }

    if (this.doSaveFlag && this.hasChange) {
      let vals: Set<string> = null; 
      if(this.lineDS.selectedItems.length > 0) {
        // ici, on teste les item.rawVals pour les agrégats de dates
        vals = new Set();
        this.lineDS.selectedItems.forEach(iwi => {
          if(iwi.rawVals?.length > 0) {
            iwi.rawVals.forEach(s => {
              vals.add(s);
            });
          } else {
            vals.add(iwi.rawVal);
          }
        });
        
        // vals = new Set(this.lineDS.selectedItems.map(item => item.rawVal));
      }
      this.filter.values = vals;
      this.filter.regex = newExp;
      if (newExp) {
        this.filter.comparator = newExp.split(ViewData.KEY_SEPARATOR)[0];
      } else {
        this.filter.comparator = null;
      }
      
      this.callback(this.filter);
    }
  }

  /**
   * alimentation des filtres depuis une mesure
   */
  private feedFromMeasure(): void {
    
    let cols: WizColDef[] = [];
    
    let fkd: FeiKeyDef = this.filter.fkd;
    let col: any = this.widget.model.feiEngine.buildGridColumn(fkd, this.widget, this.filter.wcio, 'row', true);
    if(!!col) {
      // override du rendu, ce ne sera pas des widgetlines
      col.valueGetter = this.valueAccessorM.bind(this);
      col.valueFormatter = this.valueFormatterAccessorM.bind(this);
      col.tooltipValueGetter = this.valueFormatterAccessorM.bind(this);
      col.headerComponentParams = { enableMenu:false}; // neutralisation de la conf
      col.filter = true;

      this.columns = [col];
      this.popFilter.configure([col.field], null, null); // prise en compte comme filtre
    }
  
    this.lineDS.setFilter(this.valFilterFunc.bind(this));
     
    // console.log('columns', fkd, col);


    // alimentation de la DS, on va construire les pivotFilterEntry
    // on prend soit tout les FDV, soit uniquement les valeurs par défaut
    // en cas de valeurs existantes uniquement, on prend TOUT si la DS est vide (sinon on peut pas alimenter les filtres à vide)
    let protods: IWidgetFilterItem[];
    let ds: IWidgetFilterItem[];

    // les différentes valeurs à alimenter
    let filterEntryMap: Map<string, IWidgetFilterItem> = new Map();
    // les valeurs sélectionnées
    let filterSelectMap: Map<string, IWidgetFilterItem> = new Map();
 
    // prise du FEI 
    let level: number = this.wcio.step || this.widget.fei?.visionStepLevel; // injection ou step du widget
    let fei: FeiVO = this.widget.model.dataEngine.getFei(COMPUTE_MODE.LOCAL, level, WizConstants.BASE_SCENARIO) as FeiVO;
    this.fei = fei; // surcharge
    let lines: WidgetLine[] = this.fei?.getAllLines() || null; 

    if(this.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE && lines.length === 0) { // rien dans la DS
      this.existOnly = false;
    }

    let entry: IWidgetFilterItem; // l'item à créer
    let rawVal: string; // la valeur brute sur la Widgetline, qui sert de clé
    let sortKey: any;
    let label: string;

    let isList: boolean = this.fkd.datakind === FIELD_KIND.LIST;
    if(isList) { // gestion spécifique des mesures de type liste
      this.widget.model.listFieldEngine.generateFilterCollection(this.filter); // on s'assure d'avoir les données nécessaires
      // construit dès le renderer
      filterEntryMap = this.filter.listMeasureCollection;
      // this.widget.model.listFieldEngine.generateFilterCollection(this.fei, this.fkd);
      [...filterEntryMap?.values() || []].forEach(iwf => {
        if(this.filter.values?.has(iwf.rawVal)) {
          filterSelectMap.set(iwf.rawVal, iwf);
        }
      });
      console.log('list filter ', filterSelectMap, filterEntryMap);   
     // TODO si  existOnly, filtrer pour les listes

    } else { // toutes les mesures sauf les listes
      let realFormat: string = this.wcio.fmt || this.fkd.measure.formatCode;
      let isNumeric: boolean = this.widget.model.dataEngine.datakindIsNumeric(this.fkd.datakind);
      // console.log("measFilter", this.fei);
      lines?.forEach((line: WidgetLine) => {
        rawVal = BaselineEngine.getRawKeyOrValue(this.fei, line, this.fkd.fullCode)??''; // Si la valeur est null, c'est chaine vide ('') qu'on va rechercher
        let entry: IWidgetFilterItem;       
        if(rawVal.length > 0) {
          if(!filterEntryMap.has(rawVal)) { // pas encore ajouté       
            // formater le label
            label = this.widget.model.formatEngine.applyFormat(rawVal, this.datakind, realFormat, null);
            if(isNumeric) { // cast en number si datakind numeric
              sortKey = Number(rawVal) || null;
            } else {
              sortKey = rawVal;
            }
  
            entry = {rawVal, sortKey, label, fkd, originWidgetlines: [line]};
            filterEntryMap.set(rawVal, entry);
            if(this.filter.values?.has(rawVal)) {
              filterSelectMap.set(rawVal, entry);
            }
          } else {
            filterEntryMap.get(rawVal).originWidgetlines.push(line);
          } 
        }
      });
    }
    // on trie
    protods = [...filterEntryMap.values()].sort((a, b) => a.sortKey - b.sortKey);

    // post traitement en cas de date moins précises
    if(this.fkd.datakind === FIELD_KIND.DATE) {
      let byResultMap: Map<string, IWidgetFilterItem> = new Map();
      protods.forEach(iwi => {
        if(!byResultMap.has(iwi.label)) {
          byResultMap.set(iwi.label, iwi);
          byResultMap.get(iwi.label).rawVals = [iwi.rawVal];
        } else {
          byResultMap.get(iwi.label).rawVals.push(iwi.rawVal);
        }
        
      });
      protods = [...byResultMap.values()].sort((a, b) => a.sortKey - b.sortKey);
    }
      
    ds = protods;

    this.lineDS.setSource(ds); 
    this.lineDS.select([...filterSelectMap.values()]);

    // console.log('lineDS', this.lineDS);
  }

  /**
   * méthode d'accès générique sur les baselineValues.valor, depuis la IWidgetFilterItem
   * @param params la conf d'une cellule de grid. .data contient une IWidgetFilterItem
   */
  public valueAccessorM(params: any): any {
    
    const line: IWidgetFilterItem = params.data; // ligne source
    const colDef: WizColDef = params.colDef; // définition de la colonne
    const fkd: FeiKeyDef = params.colDef.fkd; 

    let result: string = line.rawVal; // retour, pas de null

    // console.log('value', line.key, line.isTotalLine, line.isSubTotalLine,params.colDef, result);
    return result;
  }

  /** Formatte la valeur (mesure) pour un affichage cohérent */
  public valueFormatterAccessorM(params: any): string {
    
    const line: IWidgetFilterItem = params.data; // ligne source
    const colDef: WizColDef = params.colDef; // définition de la colonne
    const fkd: FeiKeyDef = params.colDef.fkd; 

    let result: any = null; 

    // interception LIST 
    // if(fkd.datakind === FIELD_KIND.LIST) { 
    //   return this.patchListFormatter(params);
    // } 
    // // interception THRESHOLD 
    // else if(fkd.datakind === FIELD_KIND.THRESHOLD) { 
    //   return this.patchThresholdFormatter(params);
    // } 
    // // interception FILTER 
    // else if(fkd.datakind === FIELD_KIND.FILTER) { 
    //   return this.patchFilterFormatter(params);
    // } 
    // // interception CROSS_FILTER 
    // else if(fkd.datakind === FIELD_KIND.FILTER) { 
    //   return this.patchCrossFilterFormatter(params);
    // } 
    // // interception Workflow 
    // else if(fkd.datakind === FIELD_KIND.WORKFLOW) { 
    //   // console.log('datakind WORKFLOW', params.colDef?.wcio?.fdvf);
    //   return this.model.workflowEngine.valueFormatter(params);
    // }      

    let aggMethod: string = null;
    let format: string = colDef.dataformat || fkd.defaultFormat;
  
    // prise du format sur le FKD, le colDef.datakind est possiblement un aggrégat d'un autre type
    let datakind: string = fkd.datakind;
    
    result = Model.getInstance().formatEngine.applyFormat(params.value, datakind, format, aggMethod);   
    return result;  
  }



}
